import { render, staticRenderFns } from "./Steppers.vue?vue&type=template&id=12c6f344"
import script from "./Steppers.vue?vue&type=script&lang=ts"
export * from "./Steppers.vue?vue&type=script&lang=ts"
import style0 from "./Steppers.vue?vue&type=style&index=0&id=12c6f344&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports